var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('font-awesome-icon',{class:_vm.header ? 'destaque-header' : 'destaque',attrs:{"icon":'spinner',"spin":""}}):_c('span',{class:_vm.header ? 'destaque-header' : 'destaque'},[_vm._v("\n  "+_vm._s(_vm.value)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-381bdab3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ValorDestaque/index.vue
// module id = D5X7
// module chunks = 15